import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import type { CONVERSATION_PAGE_ANCHOR } from '../../conversation/constants';
import type { PEOPLE_PAGE_ANCHOR } from '../../people/constants';

export const useAnchor = ({
  currentPath,
}: {
  currentPath:
    | '/workspace/$workspaceId/insight/people'
    | '/workspace/$workspaceId/insight/conversation';
}) => {
  const searchParams = useSearch({ from: currentPath }) as {
    anchor: PEOPLE_PAGE_ANCHOR | CONVERSATION_PAGE_ANCHOR;
    q: string;
    productId?: string | undefined;
    priceId?: string | undefined;
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.anchor) {
      const element = document.querySelector(`[data-anchor="${searchParams.anchor}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        navigate({
          from: currentPath,
          to: currentPath,
          search: {
            q: searchParams.q,
            productId: searchParams.productId,
            priceId: searchParams.priceId,
          },
          replace: true,
        });
      }
    }
  }, [
    searchParams.anchor,
    navigate,
    searchParams.q,
    searchParams.productId,
    searchParams.priceId,
    currentPath,
  ]);
};
